// Convex client for the admin SPA. Separate instance from the public web
// app — admin uses its own JWT (RS256, see backend lib/adminJwt.ts)
// plumbed through every query/mutation's `token` arg instead of going
// through Convex Auth.
//
// The deployment URL comes from the runtime environment choice
// (lib/environments.ts), not a build-time constant. Switching
// environments reloads the page, so this stays a module-scope singleton:
// it is rebuilt from scratch on the next load rather than swapped live.
//
// There is deliberately NO fallback URL: a fallback would let a
// misconfigured build silently point at the wrong deployment. Failing
// to boot is the correct behaviour.

import { ConvexReactClient } from 'convex/react';
import { activeConfig } from './environments';

const { convexUrl } = activeConfig();

if (!convexUrl) {
  throw new Error(
    'No Convex URL for the active admin environment. Refusing to start.',
  );
}

export const convex = new ConvexReactClient(convexUrl);
